/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ForcSurveyBasedComponent from "parog-web/components/forc/abstract/survey-based-component";

interface Person {
  gender: string;
  birthyear: number;
  city: string;
}

export default class LifestyleEditionComponent extends ForcSurveyBasedComponent {
  static fullComponentId = "lifestyle/edition";
  static forcDisplayName = "Mode de vie, situation sociale";

  get validations() {
    return {};
  }

  retrieveModel() {
    const model = super.retrieveModel();

    if (!model.children) {
      model.children = [{}];
    }

    if (!model.siblings) {
      model.siblings = [{}];
    }

    return model;
  }

  computePayload() {
    const payload = super.computePayload();
    // Remove empty chilren and siblings. This can happend in two ways:
    // - there is one child and sibling added at the initialization of the form,
    // - when adding new item, the content is not mandatory, users may not fill
    // content.
    payload.children = payload.children
      ? (payload.children as Person[]).filter(this._childIsPresent)
      : [];
    payload.siblings = payload.siblings
      ? (payload.siblings as Person[]).filter(this._childIsPresent)
      : [];

    if (
      !["activeFullTime", "activePartTime"].includes(
        payload.professionalActivity as string
      )
    ) {
      delete payload.job;
      delete payload.jobProtectedZone;
      delete payload.jobSickLeaveRelated;
    }

    if (!["unemployed"].includes(payload.professionalActivity as string)) {
      delete payload.jobLastEmployment;
    }

    if (payload.jobSickLeaveRelated == "no") {
      delete payload.jobSickLeaveDuration;
    }

    if (payload.hasChildren == "no") {
      delete payload.children;
    }

    if (payload.hasSiblings == "no") {
      delete payload.siblings;
    }

    return payload;
  }

  _childIsPresent(child) {
    return child.gender || child.birthyear || child.city;
  }
}
